import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import { Clear } from "@mui/icons-material";

import { color } from "../../StyleData/Config";
import { axiosPrivate } from "../../axios/axios";
import { masterAPI } from "../Masters/dataConfig";
import { getCurrentYearInTimeZone } from "../../utils/dateUtil";

const CURRENT_YEAR = getCurrentYearInTimeZone();

const KPIModal = ({ handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false);
  const details = editData.details || [];
  const findDetailByYear = (year) => details.find((d) => d.year === year);

  const initialValue = {
    year: CURRENT_YEAR,
    targetValue: findDetailByYear(CURRENT_YEAR)?.targetValue ?? "",
  };

  const onSubmit = async (value) => {
    setLoading(true);
    const updateLink = masterAPI["kpimaster"].update;
    try {
      const existingDetail = findDetailByYear(value.year) || {};
      const updatedDetail = {
        ...existingDetail,
        kpiMasterId: existingDetail.kpiMasterId || editData.id,
        year: Number(value.year),
        targetValue: Number(value.targetValue),
      };
      const updateKPI = {
        id: editData.id,
        Code: editData.dashboardCode || editData.Code,
        dashboardName: editData.dashboardName,
        isTarget: editData.isTarget,
        details: [updatedDetail],
      };
      const res = await axiosPrivate.put(`${updateLink}`, updateKPI);
      console.log(res.data);
      handleCloseClick();
    } catch (e) {
      console.log(e, "updateKPI");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {editData.dashboardName}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ setFieldValue }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Year
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="year"
                  placeholder="Enter Year"
                  fullWidth
                  onChange={(e) => {
                    const selectedYear = Number(e.target.value);
                    setFieldValue("year", selectedYear);
                    setFieldValue(
                      "targetValue",
                      findDetailByYear(selectedYear)?.targetValue ?? ""
                    );
                  }}
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Target Value
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="targetValue"
                  placeholder="Enter Target Value"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading ? "default" : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading ? "default" : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default KPIModal;
